export const TRANSLATIONS = {
  en: {
    amount: "Amount",
    timeLeft: "Time left",
    loadingOrder: "Loading order details...",
    error: "Error:",
    noGuid: "No order GUID provided in URL",
    failedLoad: "Failed to load order",
    clickPaymentMethod: "Choose a payment app",
    orScanQr: "Scan QR to pay",
    scanQrSubtitle: "Scan with any UPI app to complete your payment.",
    loadingQr: "Loading QR...",
    showQr: "Show QR",
    hideQr: "Hide QR",
    or: "OR",
    downloadQr: "Download QR",
    orManualTransfer: "Manual transfer details",
    manualTransferSubtitle:
      "Copy the fields below and complete the payment in your banking app.",
    copy: "Copy",
    copied: "Copied!",
    enterUtr: "Enter UTR",
    iPaid: "I paid",
    checkPaymentStatus: "Check Payment Status",
    retryIn: "Wait {{seconds}}s",
    utrRequired: "Please enter your UTR.",
    utrInvalid: "UTR must be exactly 12 digits.",
    submitFailed: "We couldn't confirm your payment. Please try again.",
    paymentError: "Something went wrong",
    tryAgain: "Try again",
    verifying: "Verifying...",
    paymentInProcess: "Payment in process",
    paymentProcessedMsg:
      "Your payment of {{amount}} is being processed. You can safely return to the shop.",
    paymentPaid: "Payment received",
    paymentPaidMsg:
      "We confirmed your payment of {{amount}}. You can safely return to the shop.",
    paymentCanceled: "Payment cancelled",
    paymentCanceledMsg:
      "This order was cancelled. Please create a new order to continue.",
    returnToShop: "Return to Shop",
    timeExpired: "Time Expired",
    timeExpiredMsg:
      "The payment time has expired. Please create a new order to continue.",
    upiId: "UPI ID",
    payeeName: "Payee Name",
    amountLabel: "Amount to pay",
    exactAmountNotice: "You must pay the exact amount shown on this page.",
    currency: "Currency",
    transactionNote: "Transaction Note",
    merchantCode: "Merchant Code",
    transactionId: "Transaction ID",
    transactionRef: "Transaction Reference",
    url: "URL",
    required: "Required",
    heroTitle: "Complete your payment",
    step1: "Choose a method",
    step2: "Pay",
    step3: "Enter UTR",
    statusWaiting: "Waiting for payment confirmation",
    qrCaption: "Scan with any UPI app",
    qrHint: "UPI ID is shown below.",
    qrCaptionKakao: "Scan with Kakao Pay",
    qrHintKakao: "Open Kakao Pay and scan this QR code to pay.",
    kakaoPayLink: "Kakao Pay link",
    qrCaptionBankKrw: "Bank transfer (KRW)",
    qrHintBankKrw:
      "Copy the details below and complete the transfer in your banking app.",
    krwRecipientName: "Recipient name",
    krwAccountNumber: "Account number",
    krwBankName: "Bank name",
    utrHint: "Bank reference number from your payment.",
    verificationHint:
      "Your UTR was sent. We're waiting for confirmation from the merchant.",
    verificationHintWithoutUTR:
      "We're waiting for confirmation from the merchant.",
  },
  hi: {
    amount: "राशि",
    timeLeft: "शेष समय",
    loadingOrder: "ऑर्डर विवरण लोड हो रहा है...",
    error: "त्रुटि:",
    noGuid: "URL में ऑर्डर GUID नहीं मिला",
    failedLoad: "ऑर्डर लोड करने में विफल",
    clickPaymentMethod: "भुगतान ऐप चुनें",
    orScanQr: "भुगतान के लिए QR स्कैन करें",
    scanQrSubtitle: "भुगतान पूरा करने के लिए किसी भी UPI ऐप से स्कैन करें।",
    loadingQr: "QR लोड हो रहा है...",
    showQr: "QR दिखाएं",
    hideQr: "QR छुपाएं",
    or: "या",
    downloadQr: "QR डाउनलोड करें",
    orManualTransfer: "मैन्युअल ट्रांसफर विवरण",
    manualTransferSubtitle:
      "नीचे दिए गए फ़ील्ड कॉपी करें और अपने बैंकिंग ऐप में भुगतान पूरा करें।",
    copy: "कॉपी करें",
    copied: "कॉपी हो गया!",
    enterUtr: "UTR दर्ज करें",
    iPaid: "मैंने भुगतान किया",
    checkPaymentStatus: "भुगतान स्थिति जांचें",
    retryIn: "{{seconds}} सेकंड रुकें",
    utrRequired: "कृपया अपना UTR दर्ज करें।",
    utrInvalid: "UTR ठीक 12 अंकों का होना चाहिए।",
    submitFailed: "हम आपके भुगतान की पुष्टि नहीं कर सके। कृपया पुनः प्रयास करें।",
    paymentError: "कुछ गलत हो गया",
    tryAgain: "पुनः प्रयास करें",
    verifying: "सत्यापित हो रहा है...",
    paymentInProcess: "भुगतान प्रक्रिया में",
    paymentProcessedMsg:
      "आपका {{amount}} का भुगतान संसाधित हो रहा है। आप सुरक्षित रूप से दुकान पर वापस जा सकते हैं।",
    paymentPaid: "भुगतान प्राप्त हुआ",
    paymentPaidMsg:
      "हमने आपका {{amount}} का भुगतान सत्यापित कर लिया है। आप सुरक्षित रूप से दुकान पर वापस जा सकते हैं।",
    paymentCanceled: "भुगतान रद्द",
    paymentCanceledMsg:
      "यह ऑर्डर रद्द कर दिया गया है। जारी रखने के लिए कृपया नया ऑर्डर बनाएं।",
    returnToShop: "दुकान पर वापस जाएं",
    timeExpired: "समय समाप्त",
    timeExpiredMsg:
      "भुगतान का समय समाप्त हो गया। जारी रखने के लिए कृपया एक नया ऑर्डर बनाएं।",
    upiId: "UPI ID",
    payeeName: "भुगतान प्राप्तकर्ता का नाम",
    amountLabel: "भुगतान राशि",
    exactAmountNotice: "आपको इस पेज पर दिखाई गई सटीक राशि का ही भुगतान करना होगा।",
    currency: "मुद्रा",
    transactionNote: "लेनदेन नोट",
    merchantCode: "मर्चेंट कोड",
    transactionId: "लेनदेन ID",
    transactionRef: "लेनदेन संदर्भ",
    url: "URL",
    required: "आवश्यक",
    heroTitle: "अपना भुगतान पूरा करें",
    step1: "तरीका चुनें",
    step2: "भुगतान करें",
    step3: "UTR भरें",
    statusWaiting: "भुगतान पुष्टि की प्रतीक्षा है",
    qrCaption: "किसी भी UPI ऐप से स्कैन करें",
    qrHint: "नीचे UPI ID दिखाया गया है।",
    qrCaptionKakao: "Kakao Pay से स्कैन करें",
    qrHintKakao: "Kakao Pay ऐप खोलकर इस QR को स्कैन करें।",
    kakaoPayLink: "Kakao Pay लिंक",
    qrCaptionBankKrw: "बैंक ट्रांसफर (KRW)",
    qrHintBankKrw:
      "नीचे दिए विवरण कॉपी करें और अपने बैंक ऐप में ट्रांसफर पूरा करें।",
    krwRecipientName: "प्राप्तकर्ता का नाम",
    krwAccountNumber: "खाता संख्या",
    krwBankName: "बैंक का नाम",
    utrHint: "आपके भुगतान का बैंक रेफरेंस नंबर।",
    verificationHint:
      "आपका UTR भेज दिया गया है। हम व्यापारी की पुष्टि का इंतज़ार कर रहे हैं।",
    verificationHintWithoutUTR:
      "हम व्यापारी की पुष्टि का इंतज़ार कर रहे हैं।",
  },
  ko: {
    amount: "금액",
    timeLeft: "남은 시간",
    loadingOrder: "주문 정보를 불러오는 중...",
    error: "오류:",
    noGuid: "URL에 주문 GUID가 없습니다",
    failedLoad: "주문을 불러오지 못했습니다",
    clickPaymentMethod: "결제 앱을 선택하세요",
    orScanQr: "QR을 스캔하여 결제",
    scanQrSubtitle: "어떤 UPI 앱으로도 스캔하여 결제를 완료할 수 있습니다.",
    loadingQr: "QR 로딩 중...",
    showQr: "QR 보기",
    hideQr: "QR 숨기기",
    or: "또는",
    downloadQr: "QR 다운로드",
    orManualTransfer: "수동 이체 정보",
    manualTransferSubtitle:
      "아래 항목을 복사해 은행 앱에서 결제를 완료하세요.",
    copy: "복사",
    copied: "복사됨!",
    enterUtr: "UTR 입력",
    iPaid: "결제했어요",
    checkPaymentStatus: "결제 상태 확인",
    retryIn: "{{seconds}}초 후 다시 시도",
    utrRequired: "UTR을 입력해 주세요.",
    utrInvalid: "UTR은 정확히 12자리 숫자여야 합니다.",
    submitFailed: "결제를 확인하지 못했습니다. 다시 시도해 주세요.",
    paymentError: "문제가 발생했습니다",
    tryAgain: "다시 시도",
    verifying: "확인 중...",
    paymentInProcess: "결제 처리 중",
    paymentProcessedMsg:
      "{{amount}} 결제가 처리 중입니다. 안전하게 쇼핑몰로 돌아가셔도 됩니다.",
    paymentPaid: "결제 완료",
    paymentPaidMsg:
      "{{amount}} 결제가 확인되었습니다. 안전하게 쇼핑몰로 돌아가셔도 됩니다.",
    paymentCanceled: "결제 취소됨",
    paymentCanceledMsg:
      "이 주문은 취소되었습니다. 계속하려면 새 주문을 생성해 주세요.",
    returnToShop: "쇼핑몰로 돌아가기",
    timeExpired: "시간 만료",
    timeExpiredMsg:
      "결제 가능 시간이 만료되었습니다. 계속하려면 새 주문을 생성해 주세요.",
    upiId: "UPI ID",
    payeeName: "수취인 이름",
    amountLabel: "결제 금액",
    exactAmountNotice: "이 페이지에 표시된 정확한 금액을 결제해야 합니다.",
    currency: "통화",
    transactionNote: "거래 메모",
    merchantCode: "가맹점 코드",
    transactionId: "거래 ID",
    transactionRef: "거래 참조",
    url: "URL",
    required: "필수",
    heroTitle: "결제를 완료하세요",
    step1: "방법 선택",
    step2: "결제",
    step3: "UTR 입력",
    statusWaiting: "결제 확인을 기다리는 중",
    qrCaption: "어떤 UPI 앱으로도 스캔",
    qrHint: "UPI ID는 아래에 표시됩니다.",
    qrCaptionKakao: "카카오페이로 스캔하여 결제",
    qrHintKakao: "카카오페이 앱에서 이 QR 코드를 스캔하세요.",
    kakaoPayLink: "카카오페이 링크",
    qrCaptionBankKrw: "계좌이체 (KRW)",
    qrHintBankKrw:
      "아래 정보를 복사해 은행 앱에서 이체를 완료하세요.",
    krwRecipientName: "수취인 이름",
    krwAccountNumber: "계좌번호",
    krwBankName: "은행명",
    utrHint: "결제의 은행 참조 번호입니다.",
    verificationHint:
      "UTR이 전송되었습니다. 판매자 확인을 기다리고 있습니다.",
    verificationHintWithoutUTR:
      "판매자 확인을 기다리고 있습니다.",
  },
};

export const UPI_FIELD_TRANSLATIONS = {
  en: {
    pa: "UPI ID",
    pn: "Payee Name",
    am: "Amount",
    cu: "Currency",
    tn: "Transaction Note",
    mc: "Merchant Code",
    tid: "Transaction ID",
    tr: "Transaction Reference",
    url: "URL",
  },
  hi: {
    pa: "UPI ID",
    pn: "भुगतान प्राप्तकर्ता का नाम",
    am: "राशि",
    cu: "मुद्रा",
    tn: "लेनदेन नोट",
    mc: "मर्चेंट कोड",
    tid: "लेनदेन ID",
    tr: "लेनदेन संदर्भ",
    url: "URL",
  },
  ko: {
    pa: "UPI ID",
    pn: "수취인 이름",
    am: "금액",
    cu: "통화",
    tn: "거래 메모",
    mc: "가맹점 코드",
    tid: "거래 ID",
    tr: "거래 참조",
    url: "URL",
  },
};
